import { ref } from 'vue';
import type { Router } from 'vue-router';
import { Capacitor } from '@capacitor/core';

/**
 * Fichier reçu d'une autre app par la feuille de partage (photo de ticket,
 * PDF de facture fournisseur) : il attend ici que la page Dépenses le prenne
 * pour l'analyser. En mémoire seulement — rien n'est conservé s'il n'est pas lu.
 */
export const pendingSharedFile = ref<File | null>(null);

export function takeSharedFile(): File | null {
  const file = pendingSharedFile.value;
  pendingSharedFile.value = null;
  return file;
}

const ACCEPTED = /^(image\/|application\/pdf$)/;

export async function setupShareTarget(router: Router, onError: (message: string) => void): Promise<void> {
  // iOS exige une extension de partage et un App Group (compte Apple payant) :
  // Android seulement pour l'instant.
  if (Capacitor.getPlatform() !== 'android') return;
  const { CapacitorShareTarget } = await import('@capgo/capacitor-share-target');
  await CapacitorShareTarget.addListener('shareReceived', async (event) => {
    const shared = event.files?.find((file) => ACCEPTED.test(file.mimeType));
    if (!shared) {
      onError('Seules les photos et les PDF peuvent être partagés avec Yakafa.');
      return;
    }
    try {
      const blob = await (await fetch(Capacitor.convertFileSrc(shared.uri))).blob();
      pendingSharedFile.value = new File([blob], shared.name || 'justificatif', { type: shared.mimeType });
      await router.push('/expenses');
    } catch {
      onError("Le fichier partagé n'a pas pu être lu.");
    }
  });
}
